export const RateUnitType = Object.freeze({
  HOURLY: 'Hourly',
  UNIT: 'Unit',
  CLIENT_UNIT_CANDIDATE_HOURLY: 'CLU_CAH',
})
